import gql from 'graphql-tag';

export const CURRENT_BUSINESS_OWNER_INFO = gql`
  {
    currentBusinessOwner {
      id
    }
    googleAnalyticsSettings {
      id
      googleAnalyticsId
    }
  }
`;

export const BUSINESS_OWNER = gql`
  {
    currentBusinessOwner {
      id
      email
      firstName
      lastName
      isSuperuser
      referencePrefix
      companyName
      phoneNumber
      isNotify
      userType
      ownerId
    }
    businessOwners {
      id
      email
      firstName
      lastName
      referencePrefix
      companyName
      phoneNumber
      isNotify
      userType
      ownerId
    }
  }
`;

export const EXISTING_BUSINESS_OWNERS = gql`
  query businessOwners($page: Int) {
    businessOwners(page: $page, numberOfOwnersPerPage: 11) {
      id
      email
      firstName
      lastName
      referencePrefix
      isNotify
      companyName
      phoneNumber
      userType
      ownerId
    }
    numberOfOwnersPages(numberOfOwnersPerPage: 11)
    businessOwnersOverview {
      total
    }
  }
`;
